
import { all, put, call, takeEvery } from "redux-saga/effects";
import { COUNTRY_BY_REGION_SUCCESS, COUNTRY_BY_REGION_LIST, SHOW__HIDE_LOADER, GET_ALL_COUNTRIES, COUNTRY_LIST_SUCCESS } from '../constants/constants';
import { getAllCountriesByRegionCallById, getAllCountries, getAllCountriesByRegionCall } from '../effects/api/api.common';

function* getAllCountriesByRegion(data: any) {
    try {
        yield put({ type: SHOW__HIDE_LOADER, payload: true });
        let response;
        if (data) {
            response = yield call(getAllCountriesByRegionCallById, data);
        } else {
            response = yield call(getAllCountriesByRegionCall);
        }

        yield put({ payload: response, type: COUNTRY_BY_REGION_SUCCESS });
        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        //
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* getAllCountriesList() {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });
        const response = yield call(getAllCountries);
        yield put({ payload: response, type: COUNTRY_LIST_SUCCESS });
        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        //
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}


export default function* CommonSaga() {
    yield all([
        takeEvery(GET_ALL_COUNTRIES, getAllCountriesList),
        takeEvery(COUNTRY_BY_REGION_LIST, getAllCountriesByRegion),
    ])
}



// WEBPACK FOOTER //
// ./src/saga/saga.common.tsx